export default "__VITE_PUBLIC_ASSET__c8f9dd8a__"